// extracted by mini-css-extract-plugin
module.exports = {"link":"ExchangeYear_link__pYab9","contents":"ExchangeYear_contents__128yl","title":"ExchangeYear_title__2j5mR","message":"ExchangeYear_message__udBhe"};